import PromoCarouselBlock from './PromoCarouselBlock';

export default PromoCarouselBlock;
